import request from '../request';

/**
    1. openFullWindowHaveBar  modeopenFullWindowHaveBar
    2. openDoc 、downloadFile 目标
    3. downloads、opendoc1 微博
    4. window.openHrm  window.openLink.openHrm 人力
    5. window.openAppLink   window.WeaRichText.openAppLink 
    6. openMeetingDiscussDoc  openMeetingAppLink  会议
    7. openWorkplanAppLink
 */
export const translateOpen = () => {
  const openHref = (href: any) => {
    if (window?.weappEmJssdk?.checkJsApi('openLink')) {
      window?.weappEmJssdk?.invoke('openLink', { url: href, openType: 2 });
    } else {
      window.open(href);
    }
  };

  const openFullWindowHaveBar = (url: string) => {
    let width = window.screen.availWidth - 10;
    let height = window.screen.availHeight - 50;
    let szFeatures = 'top=0,';
    szFeatures += 'left=0,';
    szFeatures += 'width=' + width + ',';
    szFeatures += 'height=' + height + ',';
    szFeatures += 'directories=no,';
    szFeatures += 'status=yes,toolbar=no,location=no,';
    szFeatures += 'menubar=no,';
    szFeatures += 'scrollbars=yes,';
    szFeatures += 'resizable=yes';
    window.open(url, '', szFeatures);
  };

  // 目标方法
  const openDoc = (id: any, relateId: any, type: any, obj: any) => {
    window.open('/spa/document/index.jsp?id=' + id + '#/main/document/detail');
  };

  // 目标方法
  const downloadFile = (id: any, files: any, relateId: any, type: any, obj: any) => {
    window.open('/weaver/weaver.file.FileDownload?fileid=' + files + '&download=1');
  };

  // 微博方法
  const downloads = (fileid: any) => {
    window.open('/weaver/weaver.file.FileDownload?fileid=' + fileid + '&download=1', 'window');
  };

  // 微博方法
  const opendoc1 = (showid: any, obj: any) => {
    // jQuery(obj).parents(".reportItem").attr("id"); 替换方法
    let targetNode = obj;
    let discussid;
    while (targetNode?.parentElement) {
      if (targetNode.parentElement?.getAttribute('id')) {
        discussid = targetNode.parentElement.getAttribute('id');
        targetNode = null;
        break;
      } else {
        targetNode = targetNode.parentElement;
      }
    }
    openFullWindowHaveBar(
      '/spa/document/index.jsp?id=' + showid + '&router=1&blogDiscussid=' + discussid + '#/main/document/detail'
    );
  };

  /* 
  会议e9原始代码
   window.openMeetingDiscussDoc = (t, showid, meetingid) => {
     openFullWindowHaveBar((window.ecologyContentPath || '') + `/spa/document/index2file.jsp?id=${showid}&isOpenFirstAss=1&meetingid=${meetingid}`)
   }
  */
  // 会议方法
  const openMeetingDiscussDoc = (t: any, showid: any, meetingid: any) => {
    openFullWindowHaveBar(`/spa/document/index2file.jsp?id=${showid}&isOpenFirstAss=1&meetingid=${meetingid}`);
  };

  const openMeetingAppLink = (linkType: string, linkid: string, meetingid: string) => {
    if (linkType === 'doc') window.open(`/spa/document/index.jsp?id=${linkid}&meetingid=${meetingid}`);
    else if (linkType === 'task') window.open(`/spa/prj/index.html#/main/prj/taskCard?taskid=${linkid}`);
    else if (linkType === 'crm') window.open(`/spa/crm/static/index.html#/main/crm/customerView?customerId=${linkid}`);
    else if (linkType === 'workflow')
      window.open(
        `/spa/workflow/static4form/index.html#/main/workflow/req?fromModul=meeting&modulResourceId=${meetingid}&requestid=${linkid}`
      );
    else if (linkType === 'project') window.open(`/spa/prj/index.html#/main/prj/projectCard?prjid=${linkid}`);
    else return false;
  };

  // 人力卡片打开 /spa/hrm/smallapp/openhrm?hrmid=
  const openHrm = (id: any) => {
    window.open(`/spa/hrm/smallapp/openhrm?hrmid=${id}`);
  };

  const openAppLink_old = (obj: any, linkid: any) => {
    let linkType = obj?.getAttribute('linktype');
    // no.2305513 兼容e9富文本数据方法支持老数据打开方式 06/16 徐晨康 配合调整
    // var discussid = jQuery(obj).parents('.reportItem').attr('id');
    let discussid;
    while (obj?.parentElement) {
      if (obj.parentElement?.classList?.contains('reportItem') && obj.parentElement?.getAttribute('id')) {
        discussid = obj.parentElement.getAttribute('id');
        obj = null;
        break;
      } else {
        obj = obj.parentElement;
      }
    }
    if (linkType === 'doc')
      window.open(
        '/spa/document/index.jsp?moduleid=blog&id=' +
          linkid +
          '&discussid=' +
          discussid +
          '&linkType=' +
          linkType +
          '&linkid=' +
          linkid
      );
    else if (linkType === 'task')
      window.open(
        '/spa/prj/index.html#/main/prj/taskCard?moduleid=blog&taskid=' +
          linkid +
          '&discussid=' +
          discussid +
          '&linkType=' +
          linkType +
          '&linkid=' +
          linkid
      );
    else if (linkType === 'crm')
      //标准e9,勿删
      window.open(
        '/spa/crm/static/index.html#/main/crm/customerView?customerId=' +
          linkid +
          '&discussid=' +
          discussid +
          '&linkType=' +
          linkType +
          '&linkid=' +
          linkid
      );
    //ecology正式系统定制,勿删
    else if (linkType === 'workflow')
      window.open(
        '/workflow/request/ViewRequestForwardSPA.jsp?moduleid=blog&requestid=' +
          linkid +
          '&discussid=' +
          discussid +
          '&linkType=' +
          linkType +
          '&linkid=' +
          linkid
      );
    else if (linkType === 'project')
      window.open(
        '/spa/prj/index.html#/main/prj/projectCard?moduleid=blog&prjid=' +
          linkid +
          '&discussid=' +
          discussid +
          '&linkType=' +
          linkType +
          '&linkid=' +
          linkid
      );
    else if (linkType === 'workplan')
      window.open(
        '/spa/workplan/static/index.html#/main/wp/workPlanCreateSingle?moduleid=blog&workPlanId=' +
          linkid +
          '&discussid=' +
          discussid +
          '&linkType=' +
          linkType +
          '&linkid=' +
          linkid
      );
    return false;
  };
  // app打开
  const openAppLink = (obj: any, linkid: any, linkType: any) => {
    // no.2252634 兼容e9富文本数据方法支持老数据打开方式
    if (!linkType) {
      return openAppLink_old(obj, linkid);
    }
    if (Number(linkType) === 37) {
      window.openFullWindowHaveBar
        ? openFullWindowHaveBar(`/spa/document/index.jsp?id=${linkid}&router=1#/main/document/detail`)
        : openHref(`/spa/document/static4mobile/index.html#/doc/${linkid}`);
    } else {
      let targetNode = obj;
      let discussid;
      while (targetNode?.parentElement) {
        if (targetNode.parentElement?.getAttribute('id')) {
          discussid = targetNode.parentElement.getAttribute('id');
          targetNode = null;
          break;
        } else {
          targetNode = targetNode.parentElement;
        }
      }
      if (linkType === '37')
        window.open(
          '/spa/document/index.jsp?moduleid=blog&id=' +
            linkid +
            '&discussid=' +
            discussid +
            '&linkType=' +
            linkType +
            '&linkid=' +
            linkid
        );
      else if (linkType === 'task')
        window.open(
          '/proj/process/ViewTask.jsp?moduleid=blog&taskrecordid=' +
            linkid +
            '&discussid=' +
            discussid +
            '&linkType=' +
            linkType +
            '&linkid=' +
            linkid
        );
      else if (linkType === '18')
        window.open(
          '/spa/crm/static/index.html#/main/crm/customerView?moduleid=blog&customerId=' +
            linkid +
            '&discussid=' +
            discussid +
            '&linkType=' +
            linkType +
            '&linkid=' +
            linkid
        );
      else if (linkType === '152')
        window.open(
          '/spa/workflow/index_form.jsp#/main/workflow/req?moduleid=blog&requestid=' +
            linkid +
            '&discussid=' +
            discussid +
            '&linkType=' +
            linkType +
            '&linkid=' +
            linkid
        );
      else if (linkType === '135')
        window.open(
          '/spa/prj/index.html#/main/prj/projectCard?moduleid=blog&prjid=' +
            linkid +
            '&discussid=' +
            discussid +
            '&linkType=' +
            linkType +
            '&linkid=' +
            linkid
        );
      else if (linkType === 'workplan')
        window.open(
          '/spa/workplan/static/index.html#/main/wp/workPlanCreateSingle?moduleid=blog&workid=' +
            linkid +
            '&discussid=' +
            discussid +
            '&linkType=' +
            linkType +
            '&linkid=' +
            linkid
        );
      else if (linkType === 'prjtsk')
        window.open(
          '/spa/prj/index.html#/main/prj/taskCard?taskid=' + linkid + '&linkType=' + linkType + '&linkid=' + linkid
        );
      else if (Number(linkType) === 7)
        window.open('/spa/crm/static/index.html#/main/crm/customerView?customerId=' + linkid);
      else if (Number(linkType) === 8) window.open('/spa/prj/index.html#/main/prj/projectCard?prjid=' + linkid);
    }
    return false;
  };

  const openWorkplanAppLink = (linkType: any, linkid: any, workplanid: any, isPro = false) => {
    if (linkType === 'doc') window.open(`/spa/document/index.jsp?id=${linkid}&workplanid=${workplanid}`);
    else if (linkType === 'task') window.open(`/spa/prj/index.html#/main/prj/taskCard?taskid=${linkid}`);
    else if (linkType === 'crm') window.open(`/spa/crm/static/index.html#/main/crm/customerView?customerId=${linkid}`);
    else if (linkType === 'workflow')
      window.open(
        `/spa/workflow/static4form/index.html#/main/workflow/req?fromModul=workplan&modulResourceId=${workplanid}&requestid=${linkid}`
      );
    else if (linkType === 'project') window.open(`/spa/prj/index.html#/main/prj/projectCard?prjid=${linkid}`);
    else return false;
  };

  const openHrmEvent = 'OPEN_HRM_EVENT_TARGET';
  // 记录点击事件对应的event
  const pointerXY = function (event: any) {
    window[openHrmEvent] = event;
  };

  const openhrm = function (id: string) {
    if (!id) return;
    request({
      url: `/papi/version/upgrade/trans/getMulNewTableIds?fieldName=id&oldTableName=hrmresource&oldContent=${id}&tableName=employee`,
      method: 'GET',
    }).then(
      (data) => {
        if (data?.code === 200 && data?.data && data.data[id]) {
          const hrmId = data.data[id];
          window[openHrmEvent] && window?.weappUi?.HrmCard?.openHrmCard(window[openHrmEvent], hrmId, '', 'bs/hrm');
        }
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const openProjectDiscussDoc = function (t:any, showid:any, prjid:any, auth_url:any){
    return openFullWindowHaveBar(`/spa/document/index2file.jsp?id=${showid}&isOpenFirstAss=1&prjid=${prjid}${auth_url}`)
  }

  window.openLink = {
    openHrm,
  };
  window.ecCom = {
    WeaRichText: {
      openAppLink,
    },
  };

  window.openFullWindowHaveBar = window.modeopenFullWindowHaveBar = openFullWindowHaveBar;
  // 目标执行力方法
  window.openDoc = openDoc;
  window.downloadFile = downloadFile;
  // 微博方法
  window.opendoc1 = opendoc1;
  window.downloads = downloads;
  // 会议方法
  window.openMeetingDiscussDoc = openMeetingDiscussDoc;
  window.openMeetingAppLink = openMeetingAppLink;
  // 人力方法
  window.openHrm = openHrm;
  window.openAppLink = openAppLink;
  window.openWorkplanAppLink = openWorkplanAppLink;

  window.openhrm = openhrm;
  window.pointerXY = pointerXY;
  window.openFullWindowForXtable = window.open;
  window.openProjectDiscussDoc = openProjectDiscussDoc;
};
